module.exports = __webpack_public_path__ + "img/Sun-Heroes-STUDENT-Swag-Graphic.2797eae7.jpg";